import 'intersection-observer';
import React, { useEffect, useState, useReducer, createContext } from 'react';
import axios from 'axios';
import * as c from '../ts/const';
import * as s from '../ts/store';
import Header from './containers/header';
import SaleList from './containers/sale-list';
import Copyright from './containers/copyright';
import Column from './containers/column';
import LatestInfo from './containers/latest-info';
import SalePeriod from './containers/sale-period';
import Banner from './containers/banner';
import ParticlesBox from './components/particles-box';
/**
 * コンテキスト
 */
export const SaleItemsContext = createContext([]);
/**
 * 外部データの取得
 * @param fileName
 * @returns
 */
function readData(fileName) {
    return new Promise((resolve, reject) => {
        axios.get(fileName)
            .then(res => resolve(res.data));
    });
}
const Index = () => {
    const [saleItemsState, saleItemsDispatcher] = useReducer(s.saleItemsReducer, s.initialState);
    const [appRootClassName, setAppRootClassName] = useState('');
    // 商品一覧データの取得
    useEffect(() => {
        const curerntTime = (new Date()).getTime();
        // 商品一覧データのセット
        readData(`${_SALE_ITEM_LIST_PATH}?${curerntTime}`)
            .then(res => saleItemsDispatcher({ type: 'setSaleItems', value: res }));
        // セール並び順データのセット
        readData(`${_SALE_ORDER_PATH}?${curerntTime}`)
            .then(res => saleItemsDispatcher({ type: 'setSaleOrder', value: res }));
        // ヘッダ用データのセット
        readData(`${_HEADER_PROPS_PATH}?${curerntTime}`)
            .then(res => {
            saleItemsDispatcher({ type: 'setHeaderProps', value: res });
            // ヘッダの情報が読み終わったのでページをアクティブにする
            setAppRootClassName(`active sale-period-${res.period}`);
        });
        // コラム用のデータセット
        readData(`${_COLUMN_ITEM_LIST_PATH}?${curerntTime}`)
            .then(res => saleItemsDispatcher({ type: 'setColumnItems', value: res }));
        // 最新情報用のデータセット
        readData(`${_LATEST_ITEM_LIST_PATH}?${curerntTime}`)
            .then(res => saleItemsDispatcher({ type: 'setLatestItems', value: res }));
    }, []);
    return (React.createElement("div", { className: `app-root ${appRootClassName}` },
        React.createElement(SaleItemsContext.Provider, { value: [saleItemsState, saleItemsDispatcher] },
            React.createElement("div", { className: 'bg-yellow' },
                React.createElement("div", { className: 'bg-header-base' },
                    React.createElement(ParticlesBox, { id: 'pb-1', settingsFile: `./assets/json/particles-settings-base.json?${c.CACHEBUSTER}`, largeSettingsFile: `./assets/json/particles-settings-1-md.json?${c.CACHEBUSTER}`, smallSettingsFile: `./assets/json/particles-settings-1-sm.json?${c.CACHEBUSTER}` },
                        React.createElement(Header, null),
                        React.createElement(SalePeriod, null)))),
            React.createElement("div", null,
                React.createElement(SaleList, null)),
            React.createElement("div", { className: 'bg-striped-green' },
                React.createElement(LatestInfo, null)),
            React.createElement("div", { className: 'bg-yellow' },
                React.createElement(ParticlesBox, { id: 'pb-2', settingsFile: `./assets/json/particles-settings-base.json?${c.CACHEBUSTER}`, largeSettingsFile: `./assets/json/particles-settings-1-md.json?${c.CACHEBUSTER}`, smallSettingsFile: `./assets/json/particles-settings-1-sm.json?${c.CACHEBUSTER}` },
                    React.createElement(Banner, null),
                    React.createElement(Column, null))),
            React.createElement("div", { className: 'bg-pale-yellow' },
                React.createElement(Copyright, null)))));
};
export default Index;
